import styled, { css } from 'styled-components';
import bannerBg from './banner-bg.svg';

export const Header24h34 = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  color: rgba(9, 21, 38, 0.85);
`;

const Text16h22o60 = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;
const Text16h22o85 = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.85);
`;

export const NumberText = styled(Text16h22o60)`
  width: 288px;
`;
export const DateTime = Text16h22o85;

export const ItemHeader = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: rgba(9, 21, 38, 0.85);
  width: 624px;
`;


export const InnerText = Text16h22o85;

export const BannerWrap = styled.div`
  background: #c6d7ff url(${bannerBg}) no-repeat;
  border-radius: 10px;
  width: 100%;
  height: 160px;
  padding: 16px 24px;
`;

export const BannerText = Text16h22o85;

export const BannerHeader = styled.div`
  font-size: 18px;
  line-height: 24px;
  color: rgba(9, 21, 38, 0.85);
  font-weight: bold;
`;

export const BannerRow = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Statistics = styled.div`
  display: flex;
`;

export const StatisticsItem = styled.div``;
export const MonthWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -24px;
`;
export const MonthPlate = styled.div<{ state: 'selected' | 'disabled' | 'available' }>`
  width: 128px;
  border-radius: 30px;
  padding: 11px 15px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-transform: capitalize;
  box-sizing: border-box;
  margin: 0 24px 16px 0;
  ${(props) => {
    if (props.state === 'selected') {
      return css`
        color: rgba(9, 21, 38, 0.85);
        background: #c6eafd;
      `;
    }
    if (props.state === 'disabled') {
      return css`
        color: rgba(9, 21, 38, 0.35);
        background: #f4f5f6;
      `;
    }
    if (props.state === 'available') {
      return css`
        cursor: pointer;
        color: rgba(9, 21, 38, 0.6);
        border: 1px solid rgba(9, 21, 38, 0.35);
        box-shadow: 0px 2px 4px rgba(57, 78, 127, 0.2);
      `;
    }
    return ``;
  }};
`;
